import { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import RequireAuth from './auth/RequireAuth';
import InterestsPage from './pages/InterestsPage';
import CalendarPage from './pages/CalendarPage';
import EventDetailPage from './pages/EventDetailPage';
import SettingsPage from './pages/SettingsPage';
import MyShowsPage from './pages/MyShowsPage';
import SpotifyCallbackPage from './pages/SpotifyCallbackPage';
import LandingPage from './pages/LandingPage';
import ConfirmEmailPage from './pages/ConfirmEmailPage';
import LoginDialog from './components/LoginDialog';
import SignupDialog from './components/SignupDialog';
import ForgotPasswordDialog from './components/ForgotPasswordDialog';
import ResetPasswordDialog from './components/ResetPasswordDialog';
import AboutDialog from './components/AboutDialog';
import AboutPage from './pages/AboutPage';
import VenuesPage from './pages/VenuesPage';

const SCROLL_TOP_EXCEPTION_PATHS = [
  '/signup',
  '/login',
  '/about',
  '/forgot-password',
  '/reset-password',
];

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!SCROLL_TOP_EXCEPTION_PATHS.includes(pathname)) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return null;
}

// /calendar is a redirect to the only city we ship. It preserves the query
// string because ?welcome=true reaches it via LandingPage, and the Layout the
// calendar page renders reads that param after the hop — a bare <Navigate>
// would drop it.
function CalendarRedirect() {
  const { search } = useLocation();
  return <Navigate to={`/calendar/seattle${search}`} replace />;
}

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route
          path="/login"
          element={
            <LandingPage>
              <LoginDialog />
            </LandingPage>
          }
        />
        <Route
          path="/signup"
          element={
            <LandingPage>
              <SignupDialog />
            </LandingPage>
          }
        />
        <Route
          path="/forgot-password"
          element={
            <LandingPage>
              <ForgotPasswordDialog />
            </LandingPage>
          }
        />
        <Route
          path="/reset-password"
          element={
            <LandingPage>
              <ResetPasswordDialog />
            </LandingPage>
          }
        />
        <Route
          path="/signup-about"
          element={
            <LandingPage>
              <AboutDialog />
            </LandingPage>
          }
        />
        <Route
          path="/calendar/seattle"
          element={
            <RequireAuth>
              <CalendarPage />
            </RequireAuth>
          }
        />
        <Route path="/calendar" element={<CalendarRedirect />} />
        <Route
          path="/confirm-email"
          element={
            <RequireAuth allowUnconfirmed>
              <ConfirmEmailPage />
            </RequireAuth>
          }
        />
        <Route
          path="/interests"
          element={
            <RequireAuth>
              <InterestsPage />
            </RequireAuth>
          }
        />
        <Route
          path="/events/:id"
          element={
            <RequireAuth>
              <EventDetailPage />
            </RequireAuth>
          }
        />
        <Route
          path="/my-shows"
          element={
            <RequireAuth>
              <MyShowsPage />
            </RequireAuth>
          }
        />
        <Route
          path="/settings"
          element={
            <RequireAuth>
              <SettingsPage />
            </RequireAuth>
          }
        />
        <Route
          path="/integrations/spotify/callback"
          element={
            <RequireAuth>
              <SpotifyCallbackPage />
            </RequireAuth>
          }
        />
        <Route
          path="/venues"
          element={
            <RequireAuth>
              <VenuesPage />
            </RequireAuth>
          }
        />
        <Route
          path="/about"
          element={
            <RequireAuth>
              <AboutPage />
            </RequireAuth>
          }
        />
      </Routes>
    </>
  );
}
